/**
 * Navigation Helper
 * Provides a centralized SPA-safe navigation API
 * Dispatches custom app:navigate event that App listens to
 */

export interface NavigateOptions {
  replace?: boolean;
  message?: string; // Optional toast message (e.g., "Session expired")
}

/**
 * Navigate to a path using SPA-compatible client-side routing
 * Dispatches app:navigate event which App's useNavigate hook listens to
 *
 * @param to - Target path (e.g., '/login', '/chat')
 * @param options - Optional navigation options
 */
export const navigateTo = (to: string, options: NavigateOptions = {}) => {
  window.dispatchEvent(
    new CustomEvent('app:navigate', {
      detail: {
        to,
        message: options.message,
        replace: options.replace,
      },
    }),
  );
};

/**
 * Convenience wrapper for login redirect with optional message
 */
export const redirectToLogin = (message?: string) => {
  navigateTo('/login', {
    message: message || 'Your session has expired. Please log in again.',
  });
};

/**
 * Convenience wrapper for dashboard
 */
export const navigateToDashboard = () => {
  navigateTo('/chat?dashboard=1');
};

/**
 * Convenience wrapper for a channel
 */
export const navigateToChannel = (channelId: string) => {
  navigateTo(`/chat?channel=${channelId}`);
};

/**
 * Convenience wrapper for admin panel
 */
export const navigateToAdmin = () => {
  navigateTo('/admin');
};
